import React from 'react'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'
import { precisionFormat } from 'packages/utils'

import { getTheme } from '@/utils/theme'

/**
 * 习题|测验-试卷信息卡片
 *
 * @param param - 参数
 * @param param.fullScore - 总分
 * @param param.questionCount - 题目数量
 * @param param.showScore - 显示分数
 * @param param.showEditPaperModal - 显示编辑弹窗
 * @returns React.ReactNode
 */
export const PaperInfoCard: React.FC<{
  showScore: boolean
  fullScore: number | string
  questionCount: number | string
  showEditPaperModal: () => void
}> = ({ showScore, fullScore, questionCount, showEditPaperModal }) => {
  const theme = getTheme()
  return (
    <Wrapper>
      <InfoWrapper>
        <div>题目：{questionCount}题</div>
        {showScore ? <div>满分：{precisionFormat(fullScore)}分</div> : null}
      </InfoWrapper>
      <div
        onClick={() => {
          showEditPaperModal()
        }}
      >
        <GrowpIcon
          name="Edit"
          size={14}
          text="编辑试卷"
          color={theme.brand._1}
          wrapperStyle={{
            cursor: 'pointer',
          }}
        />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 360px;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 13px 16px;
  background-color: ${(props) => props.theme.background._3};
`

const InfoWrapper = styled.div`
  width: 186px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: ${(props) => props.theme.text._3};
`
